export class DashboardFaturamento {

    public static dataSource: any[] = [
        {
            "pedidoId": 3274,
            "nf": "97548",
            "dataNF": "2021-01-11T08:49:08.317",
            "valorNF": 194,
            "clienteId": 373088,
            "cliente": "VENICIO APARECIDO PEREIRA e outro(s)",
            "filialId": 1,
            "filial": "A2W PLATAFORMA (MATRIZ)",
            "vendedorId": 444,
            "vendedor": "LUCAS MATHEUS SILVEIRA CARVALHO - MATRIZ",
            "produtoId": 947,
            "produto": "REAL MICROS (5LTs)",
            "tipoCulturaId": 36,
            "tipoCultura": "Mandioca",
            "qtdUnitario": 2,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 97,
            "pesoTotal": 10,
            "status": "4"
        },
        {
            "pedidoId": 3275,
            "nf": "32089",
            "dataNF": "2021-01-11T15:38:33.96",
            "valorNF": 243.29,
            "clienteId": 20145,
            "cliente": "ALDECIR DE SOUZA MARQUES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 224,
            "produto": "RIDOMIL GOLD MZ (1KG)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 10,
            "grupoProdutoId": 12,
            "grupoProduto": "FUNGICIDAS",
            "valorUnitario": 127.9622,
            "pesoTotal": 10,
            "status": "4"
        },
        {
            "pedidoId": 3275,
            "nf": "32224",
            "dataNF": "2021-01-21T14:27:58.713",
            "valorNF": 973.17,
            "clienteId": 20145,
            "cliente": "ALDECIR DE SOUZA MARQUES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 224,
            "produto": "RIDOMIL GOLD MZ (1KG)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 10,
            "grupoProdutoId": 12,
            "grupoProduto": "FUNGICIDAS",
            "valorUnitario": 127.9622,
            "pesoTotal": 10,
            "status": "4"
        },
        {
            "pedidoId": 3276,
            "nf": "32223",
            "dataNF": "2021-01-21T14:27:58.243",
            "valorNF": 127.72,
            "clienteId": 372711,
            "cliente": "LUIS HENRIQUE DE OLIVEIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 194,
            "produto": "DURIVO (250ML)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 17,
            "grupoProduto": "INSETICIDAS",
            "valorUnitario": 134.3542,
            "pesoTotal": 0.25,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:34.093",
            "valorNF": 1093.45,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 220,
            "produto": "VERDADERO 600WG (1KG)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 17,
            "grupoProduto": "INSETICIDAS",
            "valorUnitario": 395.4843,
            "pesoTotal": 3,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:34.093",
            "valorNF": 1093.45,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 930,
            "produto": "REAL BORORGAN (25LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 558.0474,
            "pesoTotal": 25,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:34.093",
            "valorNF": 1093.45,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 906,
            "produto": "LIQUI-PLEX CA+MG+B (5LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 38,
            "grupoProduto": "ADUBOS FOLIARES",
            "valorUnitario": 169.5691,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:36.263",
            "valorNF": 532.8,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 220,
            "produto": "VERDADERO 600WG (1KG)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 17,
            "grupoProduto": "INSETICIDAS",
            "valorUnitario": 395.4843,
            "pesoTotal": 3,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:36.263",
            "valorNF": 532.8,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 930,
            "produto": "REAL BORORGAN (25LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 558.0474,
            "pesoTotal": 25,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:36.263",
            "valorNF": 532.8,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 906,
            "produto": "LIQUI-PLEX CA+MG+B (5LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 38,
            "grupoProduto": "ADUBOS FOLIARES",
            "valorUnitario": 169.5691,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:38.46",
            "valorNF": 161.9,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 220,
            "produto": "VERDADERO 600WG (1KG)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 17,
            "grupoProduto": "INSETICIDAS",
            "valorUnitario": 395.4843,
            "pesoTotal": 3,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:38.46",
            "valorNF": 161.9,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 930,
            "produto": "REAL BORORGAN (25LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 558.0474,
            "pesoTotal": 25,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:38.46",
            "valorNF": 161.9,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 906,
            "produto": "LIQUI-PLEX CA+MG+B (5LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 38,
            "grupoProduto": "ADUBOS FOLIARES",
            "valorUnitario": 169.5691,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3274,
            "nf": "97548",
            "dataNF": "2021-01-11T08:49:08.317",
            "valorNF": 194,
            "clienteId": 373088,
            "cliente": "VENICIO APARECIDO PEREIRA e outro(s)",
            "filialId": 1,
            "filial": "A2W PLATAFORMA (MATRIZ)",
            "vendedorId": 444,
            "vendedor": "LUCAS MATHEUS SILVEIRA CARVALHO - MATRIZ",
            "produtoId": 947,
            "produto": "REAL MICROS (5LTs)",
            "tipoCulturaId": 36,
            "tipoCultura": "Mandioca",
            "qtdUnitario": 2,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 97,
            "pesoTotal": 10,
            "status": "4"
        },
        {
            "pedidoId": 3275,
            "nf": "32089",
            "dataNF": "2021-01-11T15:38:33.96",
            "valorNF": 243.29,
            "clienteId": 20145,
            "cliente": "ALDECIR DE SOUZA MARQUES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 224,
            "produto": "RIDOMIL GOLD MZ (1KG)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 10,
            "grupoProdutoId": 12,
            "grupoProduto": "FUNGICIDAS",
            "valorUnitario": 127.9622,
            "pesoTotal": 10,
            "status": "4"
        },
        {
            "pedidoId": 3275,
            "nf": "32224",
            "dataNF": "2021-01-21T14:27:58.713",
            "valorNF": 973.17,
            "clienteId": 20145,
            "cliente": "ALDECIR DE SOUZA MARQUES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 224,
            "produto": "RIDOMIL GOLD MZ (1KG)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 10,
            "grupoProdutoId": 12,
            "grupoProduto": "FUNGICIDAS",
            "valorUnitario": 127.9622,
            "pesoTotal": 10,
            "status": "4"
        },
        {
            "pedidoId": 3276,
            "nf": "32223",
            "dataNF": "2021-01-21T14:27:58.243",
            "valorNF": 127.72,
            "clienteId": 372711,
            "cliente": "LUIS HENRIQUE DE OLIVEIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 194,
            "produto": "DURIVO (250ML)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 17,
            "grupoProduto": "INSETICIDAS",
            "valorUnitario": 134.3542,
            "pesoTotal": 0.25,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:34.093",
            "valorNF": 1093.45,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 220,
            "produto": "VERDADERO 600WG (1KG)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 17,
            "grupoProduto": "INSETICIDAS",
            "valorUnitario": 395.4843,
            "pesoTotal": 3,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:34.093",
            "valorNF": 1093.45,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 930,
            "produto": "REAL BORORGAN (25LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 558.0474,
            "pesoTotal": 25,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:34.093",
            "valorNF": 1093.45,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 906,
            "produto": "LIQUI-PLEX CA+MG+B (5LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 38,
            "grupoProduto": "ADUBOS FOLIARES",
            "valorUnitario": 169.5691,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:36.263",
            "valorNF": 532.8,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 220,
            "produto": "VERDADERO 600WG (1KG)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 17,
            "grupoProduto": "INSETICIDAS",
            "valorUnitario": 395.4843,
            "pesoTotal": 3,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:36.263",
            "valorNF": 532.8,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 930,
            "produto": "REAL BORORGAN (25LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 558.0474,
            "pesoTotal": 25,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:36.263",
            "valorNF": 532.8,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 906,
            "produto": "LIQUI-PLEX CA+MG+B (5LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 38,
            "grupoProduto": "ADUBOS FOLIARES",
            "valorUnitario": 169.5691,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:38.46",
            "valorNF": 161.9,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 220,
            "produto": "VERDADERO 600WG (1KG)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 17,
            "grupoProduto": "INSETICIDAS",
            "valorUnitario": 395.4843,
            "pesoTotal": 3,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:38.46",
            "valorNF": 161.9,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 930,
            "produto": "REAL BORORGAN (25LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 558.0474,
            "pesoTotal": 25,
            "status": "4"
        },
        {
            "pedidoId": 3278,
            "nf": "32126",
            "dataNF": "2021-01-14T13:34:38.46",
            "valorNF": 161.9,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 906,
            "produto": "LIQUI-PLEX CA+MG+B (5LTs)",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 38,
            "grupoProduto": "ADUBOS FOLIARES",
            "valorUnitario": 169.5691,
            "pesoTotal": 5,
            "status": "4"
        },
        {

            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.02",
            "valorNF": 6061.71,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 818,
            "produto": "FERTILIZANTE G 18.00.17 TURBO N",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 32,
            "grupoProduto": "REAL TURBO",
            "valorUnitario": 1975.0009,
            "pesoTotal": 3000,
            "status": "6"
        },
        {
            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.02",
            "valorNF": 6061.71,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 688,
            "produto": "FERTILIZANTE G 19.00.00 TURBO N + S",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 32,
            "grupoProduto": "REAL TURBO",
            "valorUnitario": 1703.7601,
            "pesoTotal": 1000,
            "status": "6"
        },
        {
            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.02",
            "valorNF": 6061.71,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 708,
            "produto": "FERTILIZANTE F 00.19.00 SUPER SIMPLES Po",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 9,
            "grupoProduto": "FARELADO",
            "valorUnitario": 1184.9961,
            "pesoTotal": 1000,
            "status": "6"
        },
        {
            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.137",
            "valorNF": 1756.71,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 818,
            "produto": "FERTILIZANTE G 18.00.17 TURBO N",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 32,
            "grupoProduto": "REAL TURBO",
            "valorUnitario": 1975.0009,
            "pesoTotal": 3000,
            "status": "6"
        },
        {
            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.137",
            "valorNF": 1756.71,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 688,
            "produto": "FERTILIZANTE G 19.00.00 TURBO N + S",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 32,
            "grupoProduto": "REAL TURBO",
            "valorUnitario": 1703.7601,
            "pesoTotal": 1000,
            "status": "6"
        },
        {
            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.137",
            "valorNF": 1756.71,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 708,
            "produto": "FERTILIZANTE F 00.19.00 SUPER SIMPLES Po",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 9,
            "grupoProduto": "FARELADO",
            "valorUnitario": 1184.9961,
            "pesoTotal": 1000,
            "status": "6"
        },
        {
            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.26",
            "valorNF": 1252.05,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 818,
            "produto": "FERTILIZANTE G 18.00.17 TURBO N",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 3,
            "grupoProdutoId": 32,
            "grupoProduto": "REAL TURBO",
            "valorUnitario": 1975.0009,
            "pesoTotal": 3000,
            "status": "6"
        },
        {
            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.26",
            "valorNF": 1252.05,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 688,
            "produto": "FERTILIZANTE G 19.00.00 TURBO N + S",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 32,
            "grupoProduto": "REAL TURBO",
            "valorUnitario": 1703.7601,
            "pesoTotal": 1000,
            "status": "6"
        },
        {
            "pedidoId": 3460,
            "nf": "132915",
            "dataNF": "2021-01-18T08:58:41.26",
            "valorNF": 1252.05,
            "clienteId": 1270110,
            "cliente": "CARLOS DANIEL DA SILVA MENDES",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 708,
            "produto": "FERTILIZANTE F 00.19.00 SUPER SIMPLES Po",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 1,
            "grupoProdutoId": 9,
            "grupoProduto": "FARELADO",
            "valorUnitario": 1184.9961,
            "pesoTotal": 1000,
            "status": "6"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:09.5",
            "valorNF": 59.21,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 708,
            "produto": "FERTILIZANTE F 00.19.00 SUPER SIMPLES Po",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 0.05,
            "grupoProdutoId": 9,
            "grupoProduto": "FARELADO",
            "valorUnitario": 1184.2,
            "pesoTotal": 50,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:09.5",
            "valorNF": 59.21,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 748,
            "produto": "FERTILIZANTE G 25.00.25 CONVENCIONAL",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 0.1,
            "grupoProdutoId": 22,
            "grupoProduto": "MISTURA DE GRANULOS",
            "valorUnitario": 2173.31,
            "pesoTotal": 100,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:09.5",
            "valorNF": 59.21,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 224,
            "produto": "RIDOMIL GOLD MZ (1KG)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 2,
            "grupoProdutoId": 12,
            "grupoProduto": "FUNGICIDAS",
            "valorUnitario": 126.32,
            "pesoTotal": 2,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:09.5",
            "valorNF": 59.21,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 929,
            "produto": "REAL BORORGAN (5LTs)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 129,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:11.773",
            "valorNF": 217.33,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 708,
            "produto": "FERTILIZANTE F 00.19.00 SUPER SIMPLES Po",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 0.05,
            "grupoProdutoId": 9,
            "grupoProduto": "FARELADO",
            "valorUnitario": 1184.2,
            "pesoTotal": 50,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:11.773",
            "valorNF": 217.33,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 748,
            "produto": "FERTILIZANTE G 25.00.25 CONVENCIONAL",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 0.1,
            "grupoProdutoId": 22,
            "grupoProduto": "MISTURA DE GRANULOS",
            "valorUnitario": 2173.31,
            "pesoTotal": 100,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:11.773",
            "valorNF": 217.33,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 224,
            "produto": "RIDOMIL GOLD MZ (1KG)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 2,
            "grupoProdutoId": 12,
            "grupoProduto": "FUNGICIDAS",
            "valorUnitario": 126.32,
            "pesoTotal": 2,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:11.773",
            "valorNF": 217.33,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 929,
            "produto": "REAL BORORGAN (5LTs)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 129,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:13.877",
            "valorNF": 122.55,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 708,
            "produto": "FERTILIZANTE F 00.19.00 SUPER SIMPLES Po",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 0.05,
            "grupoProdutoId": 9,
            "grupoProduto": "FARELADO",
            "valorUnitario": 1184.2,
            "pesoTotal": 50,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:13.877",
            "valorNF": 122.55,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 748,
            "produto": "FERTILIZANTE G 25.00.25 CONVENCIONAL",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 0.1,
            "grupoProdutoId": 22,
            "grupoProduto": "MISTURA DE GRANULOS",
            "valorUnitario": 2173.31,
            "pesoTotal": 100,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:13.877",
            "valorNF": 122.55,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 224,
            "produto": "RIDOMIL GOLD MZ (1KG)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 2,
            "grupoProdutoId": 12,
            "grupoProduto": "FUNGICIDAS",
            "valorUnitario": 126.32,
            "pesoTotal": 2,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32129",
            "dataNF": "2021-01-14T14:06:13.877",
            "valorNF": 122.55,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 929,
            "produto": "REAL BORORGAN (5LTs)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 129,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32226",
            "dataNF": "2021-01-21T14:58:27.01",
            "valorNF": 240.01,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 708,
            "produto": "FERTILIZANTE F 00.19.00 SUPER SIMPLES Po",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 0.05,
            "grupoProdutoId": 9,
            "grupoProduto": "FARELADO",
            "valorUnitario": 1184.2,
            "pesoTotal": 50,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32226",
            "dataNF": "2021-01-21T14:58:27.01",
            "valorNF": 240.01,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 748,
            "produto": "FERTILIZANTE G 25.00.25 CONVENCIONAL",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 0.1,
            "grupoProdutoId": 22,
            "grupoProduto": "MISTURA DE GRANULOS",
            "valorUnitario": 2173.31,
            "pesoTotal": 100,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32226",
            "dataNF": "2021-01-21T14:58:27.01",
            "valorNF": 240.01,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 224,
            "produto": "RIDOMIL GOLD MZ (1KG)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 2,
            "grupoProdutoId": 12,
            "grupoProduto": "FUNGICIDAS",
            "valorUnitario": 126.32,
            "pesoTotal": 2,
            "status": "4"
        },
        {
            "pedidoId": 3461,
            "nf": "32226",
            "dataNF": "2021-01-21T14:58:27.01",
            "valorNF": 240.01,
            "clienteId": 17361,
            "cliente": "MILTON REIS PEREIRA",
            "filialId": 8,
            "filial": "A2W PLATAFORMA (ALFENAS)",
            "vendedorId": 162,
            "vendedor": "ANDERSON HENRIQUE PEREIRA - ALFENAS",
            "produtoId": 929,
            "produto": "REAL BORORGAN (5LTs)",
            "tipoCulturaId": 1,
            "tipoCultura": "Abacate",
            "qtdUnitario": 1,
            "grupoProdutoId": 31,
            "grupoProduto": "REAL NUTRI",
            "valorUnitario": 129,
            "pesoTotal": 5,
            "status": "4"
        },
        {
            "pedidoId": 3462,
            "nf": "97764",
            "dataNF": "2021-01-14T13:03:04.053",
            "valorNF": 236.84,
            "clienteId": 373088,
            "cliente": "VENICIO APARECIDO PEREIRA e outro(s)",
            "filialId": 1,
            "filial": "A2W PLATAFORMA (MATRIZ)",
            "vendedorId": 444,
            "vendedor": "LUCAS MATHEUS SILVEIRA CARVALHO - MATRIZ",
            "produtoId": 178,
            "produto": "CALLISTO (1LT)",
            "tipoCulturaId": 36,
            "tipoCultura": "Mandioca",
            "qtdUnitario": 1,
            "grupoProdutoId": 14,
            "grupoProduto": "HERBICIDAS",
            "valorUnitario": 236.84,
            "pesoTotal": 1,
            "status": "4"
        },
        {
            "pedidoId": 3463,
            "nf": "133044",
            "dataNF": "2021-01-19T11:19:15.857",
            "valorNF": 5151.36,
            "clienteId": 20622,
            "cliente": "CARLOS JORGE PAES e outro(s)",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 51,
            "vendedor": "DOUGLAS TORRES FILHO - MUZAMBINHO",
            "produtoId": 818,
            "produto": "FERTILIZANTE G 18.00.17 TURBO N",
            "tipoCulturaId": 4,
            "tipoCultura": "Café",
            "qtdUnitario": 2.5,
            "grupoProdutoId": 32,
            "grupoProduto": "REAL TURBO",
            "valorUnitario": 1975.0009,
            "pesoTotal": 2500,
            "status": "6"
        },
        {
            "pedidoId": 3464,
            "nf": "133396",
            "dataNF": "2021-01-25T11:32:31.807",
            "valorNF": 27435.28,
            "clienteId": 14959,
            "cliente": "ALLAN DEDONIO MOREIRA CEZAR",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 109,
            "vendedor": "LUCIANO BENITES RIBEIRO MACHADO - MARIA DA FE",
            "produtoId": 718,
            "produto": "FERTILIZANTE G 00.00.60 KCL 60%",
            "tipoCulturaId": 6,
            "tipoCultura": "Milho",
            "qtdUnitario": 50,
            "grupoProdutoId": 13,
            "grupoProduto": "GRANULADO",
            "valorUnitario": 2092.6621,
            "pesoTotal": 50000,
            "status": "5"
        },
        {
            "pedidoId": 3464,
            "nf": "133395",
            "dataNF": "2021-01-25T11:32:32.4",
            "valorNF": 27435.28,
            "clienteId": 14959,
            "cliente": "ALLAN DEDONIO MOREIRA CEZAR",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 109,
            "vendedor": "LUCIANO BENITES RIBEIRO MACHADO - MARIA DA FE",
            "produtoId": 718,
            "produto": "FERTILIZANTE G 00.00.60 KCL 60%",
            "tipoCulturaId": 6,
            "tipoCultura": "Milho",
            "qtdUnitario": 50,
            "grupoProdutoId": 13,
            "grupoProduto": "GRANULADO",
            "valorUnitario": 2092.6621,
            "pesoTotal": 50000,
            "status": "5"
        },
        {
            "pedidoId": 3464,
            "nf": "133418",
            "dataNF": "2021-01-25T14:04:49.073",
            "valorNF": 27435.28,
            "clienteId": 14959,
            "cliente": "ALLAN DEDONIO MOREIRA CEZAR",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 109,
            "vendedor": "LUCIANO BENITES RIBEIRO MACHADO - MARIA DA FE",
            "produtoId": 718,
            "produto": "FERTILIZANTE G 00.00.60 KCL 60%",
            "tipoCulturaId": 6,
            "tipoCultura": "Milho",
            "qtdUnitario": 50,
            "grupoProdutoId": 13,
            "grupoProduto": "GRANULADO",
            "valorUnitario": 2092.6621,
            "pesoTotal": 50000,
            "status": "5"
        },
        {
            "pedidoId": 3464,
            "nf": "133512",
            "dataNF": "2021-01-26T13:22:47.863",
            "valorNF": 15677.3,
            "clienteId": 14959,
            "cliente": "ALLAN DEDONIO MOREIRA CEZAR",
            "filialId": 6,
            "filial": "A2W PLATAFORMA (FABRICA)",
            "vendedorId": 109,
            "vendedor": "LUCIANO BENITES RIBEIRO MACHADO - MARIA DA FE",
            "produtoId": 718,
            "produto": "FERTILIZANTE G 00.00.60 KCL 60%",
            "tipoCulturaId": 6,
            "tipoCultura": "Milho",
            "qtdUnitario": 50,
            "grupoProdutoId": 13,
            "grupoProduto": "GRANULADO",
            "valorUnitario": 2092.6621,
            "pesoTotal": 50000,
            "status": "5"
        },
    ]

}